import React from "react";
import "./spinner.css";
import { ReactComponent as LuxuryRoomLogo } from "../../images/theLuxuryRoomSubmark.svg";

export default function FullPageSpinner() {
  return (
    <div className="spinner-container">
      <div className="spinner">
        <LuxuryRoomLogo width={50} height={50} />
      </div>
    </div>
  )
}